// extracted by mini-css-extract-plugin
export default {"body":"Error_body__2uKBj"};